'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChevronIcon = function (_React$Component) {
    _inherits(ChevronIcon, _React$Component);

    function ChevronIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ChevronIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChevronIcon.__proto__ || Object.getPrototypeOf(ChevronIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (mode, width, height, primary) {
            return mode === 'up' ? _react2.default.createElement(
                'svg',
                { id: 'chevron-up-outlined', xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: width, height: height, fill: 'transparent' }),
                _react2.default.createElement('path', { fill: primary, id: 'Icon_color', 'data-name': 'Icon color', d: 'M5.278.22A.75.75,0,0,1,5.808,0h.38a.77.77,0,0,1,.53.22l5.13,5.14a.5.5,0,0,1,0,.71l-.71.71a.49.49,0,0,1-.7,0L6,2.33,1.558,6.78a.5.5,0,0,1-.71,0l-.7-.71a.5.5,0,0,1,0-.71Z', transform: 'translate(6.002 8)' })
            ) : _react2.default.createElement(
                'svg',
                { id: 'chevron-down-outlined', xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: '24', height: '24', fill: 'transparent' }),
                _react2.default.createElement('path', { fill: primary, id: 'Icon_color', 'data-name': 'Icon color', d: 'M6.718,6.708a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L.148,1.568a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L6,4.6l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z', transform: 'translate(6.002 9.072)' })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ChevronIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || 24;
            return this.getIcon(this.props.mode, size, size, _colors.Colors.Primary);
        }
    }]);

    return ChevronIcon;
}(_react2.default.Component);

exports.default = ChevronIcon;